import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateCollectionByPath } from '../../modules/actions';
import { useCollectionSettingsFieldUpdate } from './useCollectionSettingsFieldUpdate';

const generatePin = () => Math.random().toString(36).replace('0.', '').substr(0, 4).toUpperCase();

export const useSettingsDownloadPin = () => {
  const dispatch = useDispatch();
  const { changeFormHandler } = useCollectionSettingsFieldUpdate();

  // Toggling the PIN switch also (re)generates the PIN itself.
  const updatePin = useCallback(
    (value: string | boolean) => {
      const pin = value ? generatePin() : 0;
      changeFormHandler('downloadPinActive', value);
      changeFormHandler('downloadPin', pin);
      dispatch(
        updateCollectionByPath({
          path: 'downloadPinActive',
          value
        })
      );
      dispatch(
        updateCollectionByPath({
          path: 'downloadPin',
          value: pin
        })
      );
    },
    [dispatch, changeFormHandler]
  );

  return { updatePin };
};
